if (!customElements.get('l20-five-txtimg')) {
  class L20FiveTxtimg extends HTMLElement {
    connectedCallback() {
      this.media = this.querySelector('[data-l20-five-media]');
      this.revealItems = Array.from(this.querySelectorAll('[data-l20-five-reveal]'));
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.hasRevealed = false;

      if (this.revealItems.length === 0) return;

      this.classList.add('is-ready');

      if (this.reduceMotion) {
        this.reveal();
        return;
      }

      this.handlePointerMove = this.onPointerMove.bind(this);
      this.handleFocusIn = this.reveal.bind(this);

      this.media?.addEventListener('pointermove', this.handlePointerMove, { passive: true });
      this.addEventListener('focusin', this.handleFocusIn);

      this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
        root: null,
        threshold: [0.35, 0.55]
      });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.media?.removeEventListener('pointermove', this.handlePointerMove);
      this.removeEventListener('focusin', this.handleFocusIn);
      this.observer?.disconnect();
    }

    onPointerMove(event) {
      if (this.hasRevealed || !this.media) return;

      const rect = this.media.getBoundingClientRect();
      if (!rect.width || !rect.height) return;

      const x = (event.clientX - rect.left) / rect.width;
      const y = (event.clientY - rect.top) / rect.height;

      if (x > 0.32 && x < 0.68 && y > 0.24 && y < 0.76) {
        this.reveal();
      }
    }

    onIntersect(entries) {
      if (this.hasRevealed) return;

      const entry = entries.find((item) => item.isIntersecting);
      if (!entry) return;

      const isTouchLayout = window.matchMedia('(hover: none), (pointer: coarse)').matches;
      if (isTouchLayout || entry.intersectionRatio >= 0.55) {
        this.reveal();
      }
    }

    reveal() {
      if (this.hasRevealed) return;

      this.hasRevealed = true;
      this.classList.add('is-revealed');
      this.media?.removeEventListener('pointermove', this.handlePointerMove);
      this.observer?.disconnect();
    }
  }

  customElements.define('l20-five-txtimg', L20FiveTxtimg);
}
